import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/banner_mobileApp_04_m.svg")